import { SOLUTION } from "@/lib/constants";
import { BellRing, Zap, CalendarCheck, ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const iconMap = { BellRing, Zap, CalendarCheck };

export default function SolutionOverview() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      data-testid="solution-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-[#1A1A1A] tracking-tight mb-6">
            {SOLUTION.heading}
          </h2>
          <p className="text-[#6B7280] text-base md:text-lg leading-relaxed">
            {SOLUTION.body}
          </p>
        </div>

        {/* 3-Step process */}
        <div
          ref={ref}
          className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0"
        >
          {SOLUTION.steps.map((step, i) => {
            const Icon = iconMap[step.icon];
            return (
              <div
                key={step.label}
                className={`flex items-center transition-all duration-500 ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <div
                  data-testid={`solution-step-${i}`}
                  className="flex flex-col items-center text-center w-56"
                >
                  <div className="w-16 h-16 rounded-2xl bg-[#D8FFB8] flex items-center justify-center mb-4">
                    {Icon && <Icon className="h-7 w-7 text-[#20611B]" />}
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-[#1A1A1A] mb-1">
                    {step.label}
                  </h3>
                  <p className="text-sm text-[#6B7280]">{step.subtext}</p>
                </div>

                {/* Arrow connector */}
                {i < SOLUTION.steps.length - 1 && (
                  <div className="hidden md:flex items-center px-4">
                    <ArrowRight className="h-5 w-5 text-[#20611B]/40" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
